import type { AccountId } from '@atlassian/jira-shared-types/src/general.tsx';
import type { AvatarDetails, AssigneeType } from '../../model/types';
import type { AppState } from '../types';
import type { EntitiesState } from './types';

export const entitiesSelector = (state: AppState): EntitiesState => state.entities;

export const projectKeySelector = (state: AppState): string => entitiesSelector(state).projectKey;

export const projectUrlSelector = (state: AppState): string => entitiesSelector(state).projectUrl;

export const projectNameSelector = (state: AppState): string => entitiesSelector(state).projectName;

export const projectTeamTypeSelector = (state: AppState): string | undefined =>
	entitiesSelector(state).projectTeamType;

export const projectTeamTypeFreeTextSelector = (state: AppState): string | undefined =>
	entitiesSelector(state).projectTeamTypeFreeText;

export const projectDescriptionSelector = (state: AppState): string =>
	entitiesSelector(state).projectDescription;

export const projectAvatarSelector = (state: AppState): AvatarDetails | undefined =>
	entitiesSelector(state).avatar;

export const projectAvatarIdSelector = (state: AppState): number | undefined => {
	const projectAvatar = projectAvatarSelector(state);
	if (projectAvatar) {
		return projectAvatar.id;
	}
	return undefined;
};

export const projectPredefinedAvatarsSelector = (state: AppState): AvatarDetails[] =>
	state.entities.predefinedAvatars;

export const hasFetchDataErrorSelector = (state: AppState): boolean =>
	entitiesSelector(state).hasFetchDataError;

export const hasFetchAvatarErrorSelector = (state: AppState): boolean =>
	entitiesSelector(state).hasFetchAvatarError;

export const projectCategorySelector = (state: AppState): string | undefined =>
	entitiesSelector(state).projectCategoryId;

export const projectLeadAccountIdSelector = (state: AppState): AccountId =>
	entitiesSelector(state).projectLeadAccountId;

export const assigneeTypeSelector = (state: AppState): AssigneeType =>
	entitiesSelector(state).assigneeType;

export const isFetchingDataSelector = (state: AppState): boolean =>
	!hasFetchDataErrorSelector(state) && !projectKeySelector(state);

export const historicalProjectKeysSelector = (state: AppState): string[] =>
	entitiesSelector(state).historicalProjectKeys;

export const formValuesSelector = (state: AppState) => ({
	projectKey: projectKeySelector(state),
	projectName: projectNameSelector(state),
	projectUrl: projectUrlSelector(state),
	projectIcon: projectAvatarSelector(state),
	projectLeadAccountId: projectLeadAccountIdSelector(state),
	projectTeamType: projectTeamTypeSelector(state),
	projectTeamTypeFreeText: projectTeamTypeFreeTextSelector(state),
	assigneeType: assigneeTypeSelector(state),
	historicalProjectKeys: historicalProjectKeysSelector(state),
});

export const getAllProjectCategories = (state: AppState) => state.entities.allProjectCategories;
